<div class="select-project view">
  <div class="select-project__title">{{ 'select-project.title' | transloco }}</div>

  <div *ngIf="loading" class="select-project__status">
    {{ 'common.loading' | transloco }}
  </div>

  <div *ngIf="!loading && projects.length === 0" class="select-project__status select-project__status--error">
    {{ 'select-project.no-projects' | transloco }}
  </div>

  <div class="select-project__list" *ngIf="!loading && projects.length > 0">
    <button
      class="btn btn-secondary"
      *ngFor="let project of projects"
      [class.active]="project.projectId === selectedProjectId"
      (click)="selectProject(project.projectId)"
    >
      {{ project.displayName }}
    </button>
  </div>
</div>

